import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../common/Api";
import { sortByObjName } from "../common/Utils";
import moment from "moment";

export class RegionFilterStore {
  parent: any;

  notReset: string[] = [];
  showPeriod = true;
  showSearchBtn = true;
  showResetBtn = true;
  periodLabel = "Period";

  regionTree: any[] = [];

  constructor(store: any) {
    makeAutoObservable(this, {
      parent: false,
      regions: computed,
      divisions: computed,
      communities: computed,
    });
    this.parent = store;
    // this.init2();
  }

  get regions() {
    return this.regionTree.map((x) => x).sort(sortByObjName);
  }

  get divisions() {
    const region = this.regionTree.find((x: any) => x.id === this.parent.filter.regionId);
    const items = [...(region?.divisions || [])].sort(sortByObjName);
    return [{ id: "", name: "All" }, ...items];
  }

  get communities() {
    const item = this.divisions.find((x: any) => x.id === this.parent.filter.divisionId);
    const items = [...(item?.communities || [])].sort(sortByObjName);
    return [{ id: "", name: "All" }, ...items];
  }

  @action onRegion(regionId) {
    this.parent.filter.regionId = regionId;
    this.parent.filter.divisionId = "";
    this.parent.filter.communityId = "";
  }

  @action onDivision(divisionId) {
    this.parent.filter.divisionId = divisionId;
    this.parent.filter.communityId = "";
  }
  @action onCommunity(communityId) {
    this.parent.filter.communityId = communityId;
  }

  @action onPeriod(value) {
    this.parent.filter.period = value;
  }

  @action onSearch(history) {
    let period: string[] = [];
    if (this.parent.filter.period?.[0]) {
      period = [
        moment(this.parent.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.parent.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.parent.filter, period, page: 1 });
    history.push({ search: query.toString() });
  }

  @action onPage(history, page, pageSize) {
    const query = new URLSearchParams({ ...this.parent.filter, page, pageSize });
    history.push({ search: query.toString() });
  }

  @action onReset(history) {
    let obj = {};
    this.notReset.map((x) => {
      obj[x] = this.parent.filter[x];
    });
    const query = new URLSearchParams(obj);
    history.push({ search: query.toString() });
  }

  @action loadRegions() {
    Api.me.regionsTree().then((res) => {
      runInAction(() => {
        this.regionTree = res.data.regions;
      });
    });
  }
}
